import {JSONItemBase} from "PDFLib/core/writers/JSONWriter/JSONItem/JSONItemBase";
import PDFObject from "PDFLib/core/objects/PDFObject";
import {encodeToBase64} from "PDFLib/utils";

export class PrecompiledJSONItem extends JSONItemBase{
    GetType() {
        return 'PC'
    }

    public Base64String;

    constructor(item:PDFObject) {
        super();
        if(item!=null) {
            let Bits = new Uint8Array(item.sizeInBytes());
            item.copyBytesInto(Bits, 0);

            this.Base64String=encodeToBase64(Bits);
        }
    }
}